export default "__VITE_ASSET__Dp5CoVR8__"